import { IntentInstallOptions } from '@wix/editor-platform-host-integration-apis';
import { BIManager, IntentInstallBIEventStep } from './BIManager';
import { IntentInstallStore } from './IntentInstallStore';

export const notifyIntentInstallDidntHappen = (
  options: IntentInstallOptions,
) => {
  const biManager = new BIManager(
    new IntentInstallStore({
      appDefinitionIds: [],
      options,
    }),
  );

  biManager.reportIntentInstallBegin(IntentInstallBIEventStep.CHECK_INSTALL);
};
